import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faPlus, faPenToSquare, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/layout/Pagination'
import { toast } from 'react-toastify';

function Coupons() {
  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('authToken');
  const [coupons, setCoupons] = useState([])
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [searchedCoupon, setSearchedCoupon] = useState('');
  const [selectedCoupon, setSelectedCoupon] = useState([])
  const [modalOpen, setModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMesage] = useState('')

  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    fetchCoupons(searchedCoupon, sortBy, pageSize, currentPage)
  }, [location.search])

  const openAddModal = () => {
    setSelectedCoupon({
      couponNumber: '',
      isActive: false,
      quantity: 0,
      ammount: 0
    });
    setModalOpen(true);
  };

  const fetchCoupons = async (searchedCoupon, sortBy, pageSize, currentPage) => {
    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/coupon/coupons?couponNumber=${searchedCoupon}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        }
      })

      if (response.status === 401) {
        navigate('/');
      }

      const result = await response.json()
      if (result?.data?.coupons) {
        const newQueryParams = new URLSearchParams(location.search);
        setCoupons(result.data.coupons);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
        setLoading(false)

        if (result.data.totalPages) {
          newQueryParams.set("totalPages", result.data.totalPages);
        }
        //navigate({ search: newQueryParams.toString() });
      } else {
        setCoupons([])
        setLoading(false)
      }
    }
    catch (error) {
    }
  }

  const handlePageSizeChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('currentPage', '1');
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setPageSize(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handleSortByChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setSortBy(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handlePageChange = (page) => {
    const newQueryParams = new URLSearchParams(location.search);

    if (page) {
      newQueryParams.set('currentPage', page);
    } else {
      newQueryParams.delete('currentPage');
    }
    navigate({ search: newQueryParams.toString() });

    setCurrentPage(page)
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
    }
    if(event.key === 'Escape'){
      clearInput();
    }
  };

  const handleSearchIconClick = () => {
    if (searchedCoupon.length > 0 && searchedCoupon.length < 2) {
      return;
    }
    fetchCoupons(searchedCoupon, sortBy, pageSize, currentPage);
  };

  const clearInput = () => {
    setSearchedCoupon('');
    fetchCoupons('', sortBy, pageSize, currentPage);
  };

  const convertDateTime = (created) => {
    if (created != null) {
      const dateObject = new Date(created);
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const datePart = dateObject.toLocaleDateString('en-GB', options);
      const timePart = dateObject.toLocaleTimeString();
      return `${datePart} ${timePart}`;
    }
  }

  const handleCoupon = () => {
    if (selectedCoupon.id) {
      handleCouponEdit()
    } else {
      handleCouponAdd()
    }
  };

  const validateInputs = () => {
    const newErrors = {};

    if (!selectedCoupon.couponNumber) newErrors.couponNumber = "Бројот на купонот е задолжителен!";
    if (selectedCoupon.quantity === "" || selectedCoupon.quantity === null || selectedCoupon.quantity === undefined || isNaN(selectedCoupon.quantity))
      newErrors.quantity = "Количината на купони е задолжителна!";
    if (selectedCoupon.ammount === "" || selectedCoupon.ammount === null || selectedCoupon.ammount === undefined || isNaN(selectedCoupon.ammount))
      newErrors.ammount = "Намалувањето е задолжително!";


    return Object.keys(newErrors).length > 0 ? newErrors : null;  // Врати го новиот објект со грешки ако има или null ако нема грешки
  };

  const handleCouponEdit = async () => {
    setLoading(true)
    const validationErrors = validateInputs();

    if (validationErrors) {
      setErrors(validationErrors);
      setLoading(false)
      return;
    }

    const response = await fetch(`${API_URL}/Coupon/${selectedCoupon.id}`, {
      method: 'PUT',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      },
      body: JSON.stringify(selectedCoupon),
    })

    const result = await response.json()

    if (result.statusCode === 204) {
      setCoupons(coupons.map(coupon =>
        coupon.id === selectedCoupon.id ? selectedCoupon : coupon
      ));
      closeEditModal();
      setLoading(false)
      toast.success(`${selectedCoupon.couponNumber} е успешно ажуриран!`);
    } else {
      setErrors({});
      setErrorMesage("Купонот не е успешно променет!");
      setLoading(false)
    }
  };

  const handleCouponAdd = async () => {
    setLoading(true)
    const validationErrors = validateInputs();

    if (validationErrors) {
      setErrors(validationErrors);
      setLoading(false)
      return;
    }

    const response = await fetch(`${API_URL}/coupon/addCoupon`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      },
      body: JSON.stringify(selectedCoupon),
    })

    const result = await response.json()

    if (result.statusCode === 201) {
      setCoupons([...coupons, result.data]);
      closeEditModal();
      setLoading(false)
      toast.success(`${selectedCoupon.couponNumber} е успешно додаден!`);
    } else {
      setErrors({});
      setErrorMesage("Купонот не е успешно додаден!");
      setLoading(false)
    }
  };

  const closeEditModal = () => {
    setModalOpen(false);
    setSelectedCoupon(null);
    setErrors({});
    setErrorMesage("")
  };

  const openEditModal = (coupon) => {
    setSelectedCoupon(coupon);
    setModalOpen(true);
  };

  const handleQuantityChange = (e) => {
    const updatedCoupon = { 
      ...selectedCoupon, 
      isActive: parseInt(e.target.value) > 0 ? selectedCoupon.isActive : false ,
      quantity: parseInt(e.target.value)
    };
    setSelectedCoupon(updatedCoupon);
  };

  return (
    <div className="p-6">
      <div className='flex flex-col'>
        <div className='ml-auto'>
          <label htmlFor='pageSize'>Прикажи:</label>
          <select
            className="mb-4"
            name='pageSize'
            id='pageSize'
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className='ml-auto'>
          <select
            className="mb-4"
            name='sortBy'
            value={sortBy}
            onChange={handleSortByChange}
          >
            <option value="">Стандардно подредување</option>
            <option value="created_desc">Најновите први</option>
            <option value="created_asc">Најстарите први</option>
          </select>
        </div>
        <div className="flex justify-between">
          <div className='flex items-center border border-gray-300 rounded-lg p-[1px] max-w-[180px] mr-1'>
            <input
              type="text"
              className="flex-grow p-1 outline-none w-full"
              placeholder="Пребарувај купони"
              value={searchedCoupon}
              onChange={(e) => setSearchedCoupon(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            {searchedCoupon && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                className="h-5 w-5 text-gray-500 cursor-pointer"
                onClick={clearInput}
              >
                <path
                  fillRule="evenodd"
                  d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-5 w-5 text-gray-500 cursor-pointer"
              onClick={handleSearchIconClick}
            >
              <path
                fillRule="evenodd"
                d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div>
            <button className='btn btn-primary btn-sm' onClick={openAddModal}>
              <FontAwesomeIcon icon={faPlus} />
              Додади Купон
            </button>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table table-zebra table-sm min-w-[600px] w-full text-[13px]">
          <thead>
            <tr className='text-[13px]'>
              <th className='w-[30px]'>Id</th>
              <th className='p-[5px]'>Број на купон</th>
              <th className='p-[5px]'>Статус</th>
              <th className='p-[5px]'>Количина</th>
              <th className='p-[5px]'>Намалување</th>
              <th className='p-[5px]'>Креиран</th>
              <th className='p-[5px]'>Последнa изменa</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map(coupon => (
              <tr key={coupon.id}>
                <td>{coupon.id}</td>
                <td className='font-semibold text-base'>{coupon.couponNumber}</td>
                <td>{coupon.isActive ? <FontAwesomeIcon className='text-green-500 text-xl transform scale-110' icon={faCheck} />
                  : <FontAwesomeIcon className='text-red-500 text-xl transform scale-110' icon={faXmark} />}</td>
                <td>{coupon.quantity}</td>
                <td>{coupon.ammount} %</td>
                <td>{convertDateTime(coupon.created)}</td>
                <td>{convertDateTime(coupon.lastModified)}</td>
                <td>
                  <div className="tooltip" data-tip="Измени го купонот">
                    <button
                      className="btn btn-sm btn-primary ml-2"
                      onClick={() => openEditModal(coupon)}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {coupons.length > 0 && (
          <>
            <div className='text-center'>Тековна страна: {currentPage}</div>
            <div className='text-center'>Вкупно производи: {totalItems}</div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            /></>
        )}
      </div>
      {modalOpen && selectedCoupon && (
        <div className="modal modal-open">
          <div className="modal-box max-w-[500px]">
            <div className="flex items-center justify-center p-4 flex-wrap">
              <div className="mx-auto w-full bg-white mb-auto">
                <div>
                  <h1 className='text-4xl font-bold mb-8 mt-8 text-center'>{selectedCoupon.id ? 'Промени податоци за купон' : 'Додај нов купон'}</h1>
                </div>
                {selectedCoupon.id && (<p className='text-base'>Id - {selectedCoupon.id}</p>)}
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="form-control">
                      <label className="cursor-pointer label justify-start">
                        <span className="label-text">Статус:</span>
                        <input type="checkbox" className="checkbox checkbox-success ml-4" name="isActive" id="isActive" value={selectedCoupon.isActive} checked={selectedCoupon.quantity > 0 ? selectedCoupon.isActive : false}
                          onChange={(e) => setSelectedCoupon({ ...selectedCoupon, isActive: selectedCoupon.quantity == 0 ? false : e.target.checked })} />
                      </label>
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="couponNumber" className="mb-3 block text-base font-medium text-[#07074D]">
                        Број на купон<span className='text-red-500 tooltip' data-tip="Бројот на купонот е задолжителен">*</span>
                      </label>
                      <input type="text" name="couponNumber" id="couponNumber" value={selectedCoupon.couponNumber}
                        required
                        onChange={(e) => setSelectedCoupon({ ...selectedCoupon, couponNumber: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                      {errors.couponNumber && (
                        <p className="text-red-500 text-sm mt-2">{errors.couponNumber}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className='-mx-3 flex flex-wrap'>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="quantity" className="mb-3 block text-base font-medium text-[#07074D]">
                        Количина<span className='text-red-500 tooltip' data-tip="Количината е задолжителна">*</span>
                      </label>
                      <input type="number" name="quantity" id="quantity" min={0} value={selectedCoupon.quantity}
                        required
                        onChange={handleQuantityChange}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                      {errors.quantity && (
                        <p className="text-red-500 text-sm mt-2">{errors.quantity}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="ammount" className="mb-3 block text-base font-medium text-[#07074D]">
                        Намалување<span className='text-red-500 tooltip' data-tip="Намалувањето е задолжително">*</span>
                      </label>
                      <input type="number" name="ammount" id="ammount" min={0} value={selectedCoupon.ammount}
                        required
                        onChange={(e) => setSelectedCoupon({ ...selectedCoupon, ammount: parseInt(e.target.value) })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                      {errors.ammount && (
                        <p className="text-red-500 text-sm mt-2">{errors.ammount}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-action">
              {loading && (<span className="loading loading-spinner loading-xs"></span>)}
              <button className="btn btn-success" onClick={handleCoupon} disabled={loading}>Зачувај</button>
              <button className="btn btn-warning" onClick={closeEditModal} disabled={loading}>Откажи</button>
            </div>
            {errorMessage && (<p className='text-red-600 text-right mt-4'>{errorMessage}</p>)}
          </div>
        </div>
      )
      }
    </div>
  )
}

export default Coupons
